import { render, staticRenderFns } from "./SPSystemError.vue?vue&type=template&id=60be8c2e&scoped=true"
import script from "./SPSystemError.vue?vue&type=script&lang=js"
export * from "./SPSystemError.vue?vue&type=script&lang=js"
import style0 from "./SPSystemError.vue?vue&type=style&index=0&id=60be8c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be8c2e",
  null
  
)

export default component.exports